'use client';

import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { useIsHydrated } from '../hooks/useIsHydrated';

interface DateTimeDisplay {
  dateString: string;
  format: Intl.DateTimeFormatOptions;
  displayServerTimezone?: boolean;
}

export const DateTimeDisplay: React.FC<DateTimeDisplay> = ({
  dateString,
  format,
  displayServerTimezone = false,
}) => {
  const isHydrated = useIsHydrated();

  const dateTime = DateTime.fromISO(dateString);

  const dateTimeWithServerTimezone = useMemo(
    () => dateTime.setZone(process.env.NEXT_PUBLIC_SERVER_TIMEZONE),
    [dateTime],
  );

  // Force server and client hydration/first render to use the server's timezone to avoid hydration mismatch errors
  // After page finishes hydrating, switch to user's timezone, or if desired, stay on server's timezone
  const dateTimeDisplay =
    isHydrated && !displayServerTimezone
      ? dateTime
      : dateTimeWithServerTimezone;

  return (
    <time dateTime={dateTime.toISO() ?? undefined} suppressHydrationWarning>
      {dateTimeDisplay.toLocaleString(format)}
    </time>
  );
};
